import { Component } from '@angular/core';
import { ViewController, NavParams } from "ionic-angular";
@Component({
  selector: 'page-info',
  templateUrl: 'info.html',
})
export class Info {
  testo: string;
  // num:any;
  constructor(public viewCtrl: ViewController, public navpar:NavParams) {
    this.testo = this.navpar.get('testo');
    // this.num = this.navpar.get('num');
  }

  response(res){
    this.viewCtrl.dismiss(res);
  }
}


// WEBPACK FOOTER //
// ./src/pages/info/info.ts